<template>
  <div class="docker-server">
    <iframe name="iframeChild" id="iframeChild" v-bind:src="getPageUrl"
            frameborder="0" scrolling="auto" ref="iframeDom"
    >
    </iframe>
  </div>
</template>

<script>
import request from '@/modules/projectA/api/nesting';

export default {
  name: 'deliveryCollaboration',
  data() {
    return {
      getPageUrl: ''
    }
  },
  created() {
    let configUrlType = ''
    switch (this.$route.path) {
      // 我的发货单
      case '/myDeliveryNote':
        configUrlType = '53'
        break
      // 我的发货通知单
      case '/myDeliveryNotification':
        configUrlType = '54'
        break
      // 发货单查询
      case '/shippingOrderQuery':
        configUrlType = '55'
        break
    }
    request.getCoalSupplySynergyUrl({
      configUrlType
    }).then(res => {
      if (res.status) {
        this.getPageUrl = res.data.configUrl
      }
    })
  }
};
</script>

<style lang="scss" scoped>
  /** iframe样式 */
  #iframeChild {
    width: 100%;
    height: calc(100vh - 125px);
  }
</style>